// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__8DoWM","header":"PatientQuestionnaire_header__2F-pB","info":"PatientQuestionnaire_info__3Noq9"};